import { render, staticRenderFns } from "./FilesSendToClient.vue?vue&type=template&id=031e56f4"
import script from "./FilesSendToClient.vue?vue&type=script&lang=js"
export * from "./FilesSendToClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports